export default "__VITE_ASSET__DGcfmnLA__"